module.exports = __webpack_public_path__ + "img/m-banner-fmugwkfb-en-US.8b9ce2da.png";